module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "pl-title"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Convenient Christmas Brides")]), _vm._v(" "), _c('p', {
    staticClass: "pl-author"
  }, [_vm._v("Carla Kelly"), _c('br'), _vm._v("Louise Allen"), _c('br'), _vm._v("Laurie Benson")]), _vm._v(" "), _c('p', {
    staticClass: "pl-logo"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "height": "50",
      "src": "image/Har_Historical_2012_Cab_Blk.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5d76870","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title_Page.vue
// module id = 66
// module chunks = 0